import { render, staticRenderFns } from "./ImprovementAlert.vue?vue&type=template&id=69533892&"
import script from "./ImprovementAlert.vue?vue&type=script&lang=js&"
export * from "./ImprovementAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports